import { Routes } from '@angular/router';
import {SalesOrderComponent} from "./sales-order/sales-order.component";
import {AddEditSalesOrderComponent} from "./sales-order/add-edit-sales-order/add-edit-sales-order.component";
import {PurchaseOrderComponent} from "./purchase-order/purchase-order.component";
import {AddEditPurchOrderComponent} from "./purchase-order/add-edit-purch-order/add-edit-purch-order.component";
import {ProductComponent} from "./product/product.component";
import {AddEditProductComponent} from "./product/add-edit-product/add-edit-product.component";
import { ViewSalesOrderComponent } from "./sales-order/view-sales-order/view-sales-order.component";
import { ViewPurchaseOrderComponent } from "./purchase-order/view-purchase-order/view-purchase-order.component";
import { PurchaseOrderReceiptFormComponent } from './purchase-order/purchase-order-receipt-form.component';
import { EnterpriseSubscriptionGuard } from '../security/enterprise-subscription.guard';
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';

const financeModuleData = {
    enterpriseModules: ['ACCOUNTING', 'GENERAL_LEDGER', 'SHIPMENTS'],
    enterpriseFeatureLabel: 'Finance'
};

export const orderRoutes: Routes = [
    {
        path: 'order/sales-order',
        canActivateChild: [EnterpriseSubscriptionGuard],
        data: financeModuleData,
        children: [
            {
                path: '',
                component: SalesOrderComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.order.records.view }
            },
            {
                path: 'add',
                component: AddEditSalesOrderComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.order.records.create }
            },
            {
                path: 'edit/:id',
                component: AddEditSalesOrderComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.order.records.edit }
            },
            {
                path: 'view/:id',
                component: ViewSalesOrderComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.order.records.view }
            }
        ]
    },
    {
        path: 'order/purchase-order',
        canActivateChild: [EnterpriseSubscriptionGuard],
        data: financeModuleData,
        children: [
            {
                path: '',
                component: PurchaseOrderComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.order.records.view }
            },
            {
                path: 'add',
                component: AddEditPurchOrderComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.order.records.create }
            },
            {
                path: 'edit/:id',
                component: AddEditPurchOrderComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.order.records.edit }
            },
            {
                path: 'view/:id',
                component: ViewPurchaseOrderComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.order.records.view }
            },
            {
                path: 'view/:id/receipts/new',
                component: PurchaseOrderReceiptFormComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.order.receipts.create }
            },
            {
                path: 'view/:id/receipts/:receiptId',
                component: PurchaseOrderReceiptFormComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.order.receipts.view }
            }
        ]
    },
    {
        path: 'order/products',
        canActivateChild: [EnterpriseSubscriptionGuard],
        data: financeModuleData,
        children: [
            {
                path: '',
                component: ProductComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.order.products.view }
            },
            {
                path: 'add',
                component: AddEditProductComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.order.products.create }
            },
            {
                path: 'edit/:id',
                component: AddEditProductComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.order.products.edit }
            }
        ]
    },
];
